/* eslint-disable global-require */

export default {
  navigations: [
    {
      name: '研究院简介',
      path: 'profile'
    },
    {
      name: '研究院领导',
      path: 'leader'
    },
    {
      name: '行政办公',
      path: 'office'
    },
  ],
  article: {
    title: '大家好，这里是</br>上海交通大学人工智能研究院！',

    content: [
      {
        description: '人工智能正在深刻改变社会经济发展模式。面对国家和上海市的战略部署，上海交通大学抢抓人工智能发展的重大战略机遇，集聚校内外资源，于2018年1月18日成立上海交通大学人工智能研究院（以下简称“研究院”）。',
        position: 'first',
      },
      {
        title: '研究院职能',
        description: '研究院作为上海交通大学人工智能研究实体，将加快组建实体化研究团队，成为学校人工智能科研成果转化与对外交流的统一出口，积极组织校内研究中心建设，统筹校内人工智能领域科研。'
      },
      {
        title: '发展基础',
        description: '上海交通大学在人工智能领域具有雄厚的学科基础。根据2020年QS世界大学学科排名，上海交通大学计算机科学与信息系统学科排名为第34名，电子电气工程学科排名为第29名，数学学科排名为第39名；在第四次国家一级学科评估中，支撑人工智能核心领域的计算机科学与技术、信息与通信工程、控制科学与工程科学均评为A。</br>' +
          '上海交通大学在人工智能领域汇集了一支50人左右的高水平师资队伍，包括3名两院院士、4名IEEE Fellow、2名长江学者、4名国家杰出青年基金获得者等在内的30余名国家级人才。'
      },
      {
        title: '建设内容',
        description: '研究院作为学校人工智能研究的跨学科平台，积极整合学校人工智能领域相关院系、学科的研究力量，坚持高标准、高定位，建设若干研究中心，形成交大特色的人工智能创新生态体系，建成世界一流的人工智能研究院。',
      },
      {
        title: '建设目标',
        description: '力争到2025年，聚集一批国际一流人才，成为世界人工智能基础研究的学术高地；加强人才培养，成为世界人工智能人才高地；构建创新生态, 成为人工智能成果转化高地。'
      },
    ]
  },
  offices: [
    {
      name: '都晓慧',
      phone: '34206041',
      address: '上海交通大学软件大楼5楼5-503',
      email: 'duxiaohui2010@sjtu.edu.cn',
    },
    {
      name: '黄蕾宇',
      phone: '34206041',
      address: '上海交通大学软件大楼5楼5-503',
      email: '1627hly@sjtu.edu.cn',
    },
    {
      name: '郑娇娇',
      responsibility: '',
      phone: '34206041',
      address: '上海交通大学软件大楼5楼5-503',
      email: 'zhengjiaojiao@sjtu.edu.cn',
    },
  ],
  leaders: [
    // {
    //   name: '梅宏',
    //   titles: '院长',
    //   duties: '负责研究院战略及重大决策',
    //   honours: '中国科学院院士，发展中国家科学院院士，欧洲科学院外籍院士，IEEE Fellow',
    //   avator: '~/assets/images/leaders/毛军发.png',
    // },
    {
      name: '杨小康',
      titles: '常务副院长',
      duties: '负责日常工作，分管师资、财务、平台与基地建设',
      honours: '人工智能教育部重点实验室主任,教育部长江学者特聘教授',
      avator: 'http://pic1.win4000.com/pic/8/63/b8651406907.jpg',
    },
    {
      name: '徐雷',
      titles: '首席科学家',
      duties: '分管学术方向规划和国际交流',
      honours: '欧洲科学院院士,致远讲席教授',
      avator: 'http://pic1.win4000.com/pic/8/63/b8651406907.jpg',
    },
    {
      name: '江帆',
      titles: '副院长',
      duties: '分管智能医疗方向',
      honours: '上海交通大学医学院党委书记',
      avator: 'http://pic1.win4000.com/pic/8/63/b8651406907.jpg',
    },
    {
      name: '马利庄',
      titles: '副院长',
      duties: '分管研究生培养、科研，协管国际交流',
      honours: '',
      avator: 'http://pic1.win4000.com/pic/8/63/b8651406907.jpg',
    },
    {
      name: '张希',
      titles: '副院长',
      duties: '分管智能网联汽车方向',
      honours: '',
      avator: 'http://pic1.win4000.com/pic/8/63/b8651406907.jpg',
    },
    {
      name: '王延峰',
      titles: '副院长',
      duties: '协助人工智能功能型平台推进',
      honours: '',
      avator: 'http://pic1.win4000.com/pic/8/63/b8651406907.jpg',
    },
    {
      name: '宋海涛',
      titles: '副院长',
      duties: '',
      honours: '',
    },
    {
      name: '金耀辉',
      titles: '总工程师',
      duties: '',
      honours: '',
    },
    {
      name: '何黎明',
      titles: '院长助理',
      duties: '',
      honours: '',
    }
  ],
  successive_title: '历任领导',
  successive: [
    {
      name: '毛军发',
      title: '中国科学院院士',
      text: '2018 年 1 月至 2019 年 6 月任人工智能研究院院长',
      avator: '~/assets/images/successive/img.png',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/utils/lang/about.cn.js